import { BorderRadius, Color, getShadow, Spacing, zIndex } from '@billy/design-system'
import styled from '@emotion/styled'

interface PopoverContainerProps {
  fast: string
  easeOut: string
  linear: string
}

export const PopoverContainer = styled.div<PopoverContainerProps>`
  min-width: 200px;
  max-width: 250px;
  height: auto;
  padding: ${Spacing.S16};
  border: 1px solid ${Color.Grey200};
  border-radius: ${BorderRadius.R4};
  z-index: ${zIndex.Modal};
  background-color: ${Color.White};

  ${getShadow('elevatedLight')};

  ${({ fast, easeOut, linear }) => `transition:
    transform ${fast} ${easeOut},
    opacity ${fast} ${easeOut},
    filter ${fast} ${linear}`};
`
